<template>
  <c-row>
    <loader v-show="loading" />
    <c-col col="6">
      <c-card>
        <c-card-header>
          <strong>Retur Dari Pembeli</strong>
        </c-card-header>
        <c-card-body>
          <form v-on:submit.prevent="search">
            <div class="form-group">
              <label class="col-form-label">Barcode atau Faktur</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-bind:class="{ 'has-error': hasError.unit }"
                  v-model="keyword"
                />
              </div>
            </div>
          </form>
        </c-card-body>
        <c-card-footer>
          <cr-button @onReset="reset" @onSearch="search" />
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="6">
      <c-card>
        <c-card-body>
          <!-- <c-card-header> -->
          <strong class="float-left"
            >Item no {{ this.index + 1 }} dari
            {{ this.items.length }} Item</strong
          >
          <div class="button-group float-right">
            <button
              type="button"
              class="btn btn-success btn-action"
              @click="doBack"
            >
              <i class="cil-arrow-circle-left"></i>
            </button>
            <button
              type="button"
              class="btn btn-success btn-action"
              @click="doNext"
            >
              <i class="cil-arrow-circle-right"></i>
            </button>
          </div>
          <!-- </c-card-header>
        <c-card-body> -->
          <table class="table">
            <tr>
              <td width="180">Barcode</td>
              <td width="10">:</td>
              <td>{{ item.warranty }}</td>
            </tr>
            <tr>
              <td width="180">Kode</td>
              <td width="10">:</td>
              <td>{{ item.code }}</td>
            </tr>
            <tr>
              <td>Nama Barang</td>
              <td>:</td>
              <td>{{ item.item_name }}</td>
            </tr>
            <tr>
              <td>Nama Dealer</td>
              <td>:</td>
              <td>{{ item.customer_name }}</td>
            </tr>
            <tr>
              <td>Nama Toko / Perusahaan</td>
              <td>:</td>
              <td>{{ item.perusahaan }}</td>
            </tr>
            <tr>
              <td>Pembeli</td>
              <td>:</td>
              <td>{{ item.buyer_name }}</td>
            </tr>
            <tr>
              <td>Tanggal Beli</td>
              <td>:</td>
              <td>{{ item.created_at | dateFormat }}</td>
            </tr>
            <tr>
              <td>Harga</td>
              <td>:</td>
              <td>{{ item.price | thousandSeparator }}</td>
            </tr>
            <tr>
              <td>Keterangan</td>
              <td>:</td>
              <td>{{ item.description }}</td>
            </tr>
          </table>
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-body>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-4">Tipe Retur</label>
            <div class="col-md-8">
              <select-x
                url="/api/v1/return-types"
                :size="10"
                placeholder="Pilih tipe retur"
                v-model="retur.return_type"
                @input="changeReturnType"
                v-bind:class="{ 'has-error': hasError.return_type_id }"
              />
            </div>
          </div>
          <div class="form-group form-row">
            <label class="col-form-label col-sm-4">Tanggal Retur</label>
            <div class="col-sm-8">
              <datetime
                class="date-control"
                v-model="retur.date"
                v-bind:class="{ 'has-error': hasError.date }"
              />
            </div>
          </div>
          <div class="form-group">
            <label>Alasan Retur</label>
            <textarea
              class="form-control"
              v-model="retur.reason"
              v-bind:class="{ 'has-error': hasError.reason }"
            />
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary" @click="doRetur">
            <i class="cil-list-high-priority"></i> Retur
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import CRButton from "../../components/CRButton";
import Loader from '../../components/Loader.vue';
import SelectX from '../../components/SelectX.vue';
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    "cr-button": CRButton,
    Loader,
    SelectX,
  },
  data () {
    return {
      hasError: {},
      keyword: "",
      items: [],
      item: {},
      retur: {},
      index: 0,
      loading: false
    };
  },
  created () {
    const query = this.$route.query;
    if (query.key) {
      this.keyword = query.key;
      this.search();
    }
    this.retur.date = new Date().toISOString();
  },
  methods: {
    search () {
      this.loading = true;
      if (!this.keyword) {
        this.$toasted.error("Kode garansi kosong").goAway(2000);
        this.loading = false;
        return
      }
      this.item = {};
      this.retur.date = new Date().toISOString();
      HTTPAUTH.get("/api/v1/return/search?q=" + this.keyword)
        .then(res => {
          this.items = res.data.data;
          if (this.items.length > 0) {
            this.index = 0;
            this.item = this.items[this.index];
          }
          this.$router.push({ query: { key: this.keyword } });
          this.loading = false;
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
          this.loading = false;
        });
    },
    doNext () {
      this.index++;
      if (this.index >= this.items.length) {
        this.index--;
        return;
      }
      this.item = this.items[this.index];
    },
    doBack () {
      this.index--;
      if (this.index < 0) {
        this.index++;
        return;
      }
      this.item = this.items[this.index];
    },
    doRetur () {
      const conf = confirm('Yakin akan meretur product ini ?')
      if (!conf) {
        return
      }
      if (this.retur && this.retur.return_type) {
        this.retur.return_type_id = this.retur.return_type.id;
      }
      this.loading = true
      HTTPAUTH.post(`/api/v1/return/${this.item.id}`, this.retur).then(() => {
        this.$toasted.success("Success submit retur").goAway(2000)
        this.$router.push({ query: {} });
        this.reset()
        this.loading = false
      }).catch(eres => {
        this.hasError = showErrorMessage(eres)
        this.loading = false
      })
    },
    reset () {
      this.item = {}
      this.retur = {}
      this.keyword = "";
    }
  }
};
</script>